import type { CompanyQuerySchema } from '../schemas';

export const fieldNames: Record<keyof CompanyQuerySchema, { name: string; revertible: boolean }> = {
  name: { name: 'Company', revertible: true },
  status: { name: 'Status', revertible: true },
  logo: { name: 'Logo', revertible: true },
  short_name: { name: 'Short Name', revertible: true },
  brand: { name: 'Brand', revertible: true },
  partner: { name: 'Partner', revertible: true },
  relationship_score: { name: 'Health Score', revertible: true },
  account_manager: { name: 'Account Manager', revertible: true },
  organization_type: { name: 'Organization Type', revertible: true },
  audience: { name: 'Audience', revertible: true },
  billing_system: { name: 'Billing System', revertible: true },
  magazine: { name: 'Magazine', revertible: true },
  consumers: { name: 'Consumers', revertible: true },
  year_established: { name: 'Years Established', revertible: true },
  annual_meeting_month: { name: 'Annual Meeting', revertible: true },
  industries: { name: 'Industries', revertible: true },
  tax_id: { name: 'Tax ID', revertible: true },
  exempt: { name: 'Exempt', revertible: true },
  billing_term: { name: 'Billing Term', revertible: true },
  addresses: { name: 'Address', revertible: true },
  phone_numbers: { name: 'Phone Numbers', revertible: true },

  primary_contact: { name: 'Contact', revertible: true },
  alternate_contacts: { name: 'Contact', revertible: true },

  domains: { name: 'Domains', revertible: true },

  gnt_affiliations: { name: 'G&T Affiliations', revertible: true },
  non_gnt_affiliations: { name: 'Company Affiliations', revertible: true },
  all_gnt_affiliations: { name: 'G&T Affiliations', revertible: true },
  all_non_gnt_affiliations: { name: 'Company Affiliations', revertible: true },

  subsidiaries: { name: 'Subsidiaries', revertible: true },
  primary_subsidiaries: { name: 'Subsidiary', revertible: true },

  current_web_provider: { name: 'Current Web Provider', revertible: false },
  current_web_provider_type: { name: 'Current Web Provider', revertible: false },

  contacts: { name: 'Contacts', revertible: false },
  id: { name: 'ID', revertible: false },
  audience_id: { name: 'audience_id', revertible: false },
  organization_type_id: { name: 'organization_type_id', revertible: false },
  billing_system_id: { name: 'billing_system_id', revertible: false },
  magazine_id: { name: 'magazine_id', revertible: false },
  account_manager_id: { name: 'account_manager_id', revertible: false },
  brand_id: { name: 'brand_id', revertible: false },
  partner_id: { name: 'partner_id', revertible: false },
  relationship_score_id: { name: 'relationship_score_id', revertible: false },
  zoom_meeting_code: { name: 'zoom_meeting_code', revertible: false },
  contacts_count: { name: 'contacts_count', revertible: false },
  account_number: { name: 'account_number', revertible: false },
  timezone_id: { name: 'timezone_id', revertible: false },
  pivot: { name: 'pivot', revertible: false },

  billing_term_id: { name: 'billing_term_id', revertible: false },
  current_web_provider_id: { name: 'current_web_provider_id', revertible: false },

  harvest: { name: 'Harvest', revertible: true },
  freshdesk: { name: 'Freshdesk', revertible: true },
  box: { name: 'BOx', revertible: true },
  agreements: { name: 'Agreements', revertible: false },
  marketing_campaigns: { name: 'Marketing Campaigns', revertible: false },
  client_assigned_vendor_id: { name: 'Client Assigned Vendor ID', revertible: true },
  override_payable_name: { name: 'Payee Override Name', revertible: true },
  state: { name: 'State', revertible: false },
};
